import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';

import { connectLocation } from '../../../location/LocationConnectors';

const ListHeaderElement = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1.5em 0;
  position: relative;
  width: 100%;

  @media screen and (min-width: 1200px) {
    flex-wrap: no-wrap;
    padding-bottom: 2em;
    padding-top: 2em;
  }
`;

const ContentHeader = connectLocation(
  ({ t, children, primaryActive, activatePrimary, secondaryActive, activateSecondary, headerStyle }) => (
    <ListHeaderElement css={headerStyle}>
      {React.cloneElement(children, {
        primaryActive,
        activatePrimary,
        secondaryActive,
        activateSecondary,
      })}
    </ListHeaderElement>
  )
);

// ListHeader.WrappedComponent.displayName = 'ContentHeader';

export default ContentHeader;
